import { autoinject } from 'aurelia-framework';

@autoinject
export class StructureAdminCard {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}